<div>
  <section class="fixed-header mat-elevation-z8" tabindex="0">
    <table matSort (matSortChange)="sortData($event)" mat-table [id]="tourId.workflows.wfrun.wfRunTable.id" mat-table
      [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">

      <!-- for column header and values -->

      <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay;let indexOfelement=index;">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column" [class.width30]="isDataSourceEmpty()"
          [disabled]="workflowPageObj?.isworkflowPage ? ['performance','view'].includes(column): true"
          [arrowPosition]="['avgDuration','exeTimes'].includes(column) ? 'before':'after'"
          [class.centered-sorted-header]="['reRun','performance'].includes(column)"
          [class.right-aligned-sorted-header]="['duration','avgDuration','exeTimes','count'].includes(column)"
          [class.pr_26]="adjustDuration" [class.width22]="column === 'performance'">
          {{columnHeaders[indexOfelement]}}
        </th>
        <td mat-cell *matCellDef="let element;let k = dataIndex;" [class.justify-content-end]="column === 'duration'"
          [class.rightAlign]="['count','avgDuration','exeTimes'].includes(column)" [class.width22]="column === 'count'"
          [class.width35]="column === 'empty'" [class.width11]="column === 'reRun'">

          <!-- WORKFLOW RUN COLUMNS TO ADD ICONS -->
          <!-- Branch column -->
          <!-- END WORKFLOW RUN COLUMNS TO ADD ICONS -->

          <div class="cellHeight" [ngSwitch]="column" [class.justify-content-center]="column === 'reRun'"
            [ngClass]="column === 'duration' ? enableClass:''">

            <div *ngSwitchCase="'event'" [matTooltip]="element[column]">{{ element[column] }}</div>

            <div *ngSwitchCase="'wfName'" [matTooltip]="element[column]" class="ellipses">{{ element[column] }}</div>

            <div *ngSwitchCase="'commit'" [matTooltip]="element[column]" class="commitMsg">{{ element[column] }}</div>

            <div *ngSwitchCase="'pull request'" [matTooltip]="element[column]">{{ element[column] }}</div>

            <div *ngSwitchCase="'branch'" class="ellipses" [matTooltip]="element[column]">{{ element[column] }}</div>

            <div *ngSwitchCase="'triggeredOn'" class="author width-107px" [matTooltip]="element[column]">
              <span class="material-icons">event</span>{{ element[column] | date}}
            </div>

            <div *ngSwitchCase="'author'" [matTooltip]="element[column]" class="author">
              <app-profile [userId]="element[column]" [isAPICall]="tourGuideService.isStartTour ? false : true"
                [style]="{width:'127px'}"></app-profile>
            </div>

            <div *ngSwitchCase="'runner'" class="width-85" [matTooltip]="element[column]">{{ element[column] }}</div>

            <!-- if column has specific status -->
            <div *ngSwitchCase="'specificStatus'">
              <app-type-specific-status [type]=true specifiedType="Overall" statusName={{element[column]}}>
              </app-type-specific-status>
            </div>

            <!-- if column has normal status -->
            <div *ngSwitchCase="'status'">
              <app-type-specific-status [type]=false statusName={{element[column]}}></app-type-specific-status>
            </div>

            <div fxLayout="row" fxLayoutAlign="end center" class="width100" *ngSwitchCase="'duration'">
              <div class="matIcon">
                <mat-icon>schedule</mat-icon>
              </div>
              <div>
                <span [matTooltip]="element[column] | durationFormatter">{{element[column] | durationFormatter}}</span>
              </div>

            </div>

            <!-- Feature workflows -->
            <div *ngSwitchCase="'workflowName'" class="ellipses wfName" [matTooltip]="element[column]">
              {{ element[column] }}</div>

            <!-- END feature workflows -->

            <!-- Wf queue manager/error diag table-->
            <div *ngSwitchCase="'count'" class="rightAlign width100">
              <span [matTooltip]="element[column]">{{ cf.formatCompactNumber(element[column]) }}</span>
            </div>
            <!-- END wf queue manager/error diag table-->

            <!-- Error diag table-->
            <div *ngSwitchCase="'keyword'" class="ellipses errDiagKeyword">
              <span [matTooltip]="element[column]">{{ element[column] }}</span>
            </div>
            <!-- End error diag table-->

            <!-- Workflows page columns-->
            <ng-container *ngSwitchCase="'performance'">
              <div [id]="tourId.workflows.wf.wfPerformance.id" fxLayout="row" fxLayoutAlign="space-around center"
                class="width100">
                <div *ngFor="let perfFactor of workflowPageObj.perfDtl['factors']" [matTooltip]="perfFactor | titlecase"
                  fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                  <mat-icon
                    [ngStyle]="{'color': workflowPageObj.perfDtl[perfFactor].color}">{{workflowPageObj.perfDtl[perfFactor].icon}}</mat-icon>
                  <span>{{formatNumber(element[column][perfFactor])}}</span>
                </div>
              </div>
            </ng-container>

            <div *ngSwitchCase="'repoName'" class="ellipses wfName" [matTooltip]="element[column]">
              {{ cf.substringUrl(element[column]) }}</div>

            <div *ngSwitchCase="'exeTimes'" class="ellipses rightAlign width100">
              <span [matTooltip]="element[column]">{{ cf.formatCompactNumber(element[column]) }}</span>
            </div>

            <!-- view button -->
            <div class="wd-90" *ngSwitchCase="'view'" fxLayoutAlign="end" matTooltip="Click here for more details!">
              <mat-icon class="view-icon" (click)="onView(element)">visibility</mat-icon>
              <button [id]="tourId.workflows.wf.wfView.id" class="view-btn" mat-stroked-button
                (click)="onView(element)">View</button>
            </div>
            <!-- End Workflows page columns-->

            <div *ngSwitchCase="'startTime'" [matTooltip]="element[column]"> {{element[column] | date}}</div>

            <div class="width100" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="end center"
              *ngSwitchCase="'avgDuration'">
              <span class="schedule"> <mat-icon>schedule</mat-icon> </span>
              <span [matTooltip]="element[column] | durationFormatter">{{element[column] | durationFormatter}}</span>
            </div>

            <!-- normal column -->
            <div *ngSwitchDefault class="width100" [matTooltip]="(column == 'repoName') ? element[column] :''"
              [class]="column == 'repoName'? 'commitMsg':''"> {{expandOption == 'configExpand' && column == 'id' ? k+1 :
              format(element[column])}}</div>
          </div>
        </td>

      </ng-container>

      <!-- for arrow -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="expand-header">&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <div aria-label="expand row" [id]="tourId.workflows.wfrun.wfExpand.id"
            (click)="onExpand(element); $event.stopPropagation()">

            <div
              *ngIf="(expandOption == 'configExpand' && expandedElement?.id !== element.id) || (expandOption !== 'configExpand' && expandedElement !== element)"
              class="cursor icon-container" [matTooltip]="expandIcon" aria-hidden="true"><mat-icon>add</mat-icon></div>
            <div
              *ngIf="(expandOption == 'configExpand' && expandedElement?.id === element.id) || (expandOption !== 'configExpand' && expandedElement === element)"
              class="cursor icon-container" [matTooltip]="collapseIcon" aria-hidden="true"><mat-icon>remove</mat-icon>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="refresh">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">
          <div class="refresh"><i style="font-size:18px" class="fa" (click)="refresh()"
              [matTooltip]="refreshIcon">&#xf021;</i></div>
        </th>
        <td mat-cell *matCellDef="">
        </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">

        <td class="expandend-card-td fit-content" mat-cell *matCellDef="let element, let i = dataIndex"
          [attr.colspan]="columnsToDisplayWithExpand.length">
          <div
            *ngIf="(expandOption == 'configExpand' && element?.id && element?.id == expandedElement?.id) || (expandOption !== 'configExpand' && element == expandedElement)"
            class="expandend-card example-element-detail zindex"
            [@detailExpand]="(expandOption == 'configExpand' && element?.id && element?.id == expandedElement?.id)  || (expandOption !== 'configExpand' && element == expandedElement) ? 'expanded' : 'collapsed'">
            <div class="expanded-component-container" [ngSwitch]="expandOption">

              <!-- for expand view of workflow queue manager config row  -->
              <app-que-mnger-expand-config [duration]=duration [wfId]=element?.id *ngSwitchCase="'configExpand'"
                [dataSource]="queueData" (_data)="queuedData($event)">
              </app-que-mnger-expand-config>

              <!-- for expand view of feature workflow  page workflow -->
              <app-feature-workflow-expand [jobId]="element['jobId']" *ngSwitchCase="'featureWorkflowExpand'">
              </app-feature-workflow-expand>

              <app-table-normal *ngSwitchCase="'errorDignostic'" [columnsToDisplay]=errorDignoColumnsToDisplay
                [columnHeaders]=errorDignoColumnHeaders [dataSource]=errorDignoexpandDataSource></app-table-normal>
              <!-- if dont have any expand view -->
              <div *ngSwitchDefault> </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- header row -->
      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand; sticky: true"></tr>

      <!-- row of values -->
      <tr class="table-row-height" mat-row
        *matRowDef="let element; columns: columnsToDisplayWithExpand;let k = dataIndex;"
        [id]="(expandOption == 'configExpand' ?  k == 0 ? 'que-wfQueTableId':'': k == 0 ? 'wf-featureId':'')"
        class="example-element-row" [class.example-expanded-row]="expandedElement === element"
        (click)="onExpand(element)">
      </tr>
      <!-- expand logic -->

      <tr mat-row class="fit-content" *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

      <!--This row will be displayed when there is no data available-->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan=9>
          <!-- No data available -->
          <app-no-data-available [newData]="getNoData"></app-no-data-available>
        </td>
      </tr>

    </table>
  </section>
  <mat-paginator [pageSizeOptions]="constantsService.pageSizeOptions" showFirstLastButtons
    aria-label="Select page of periodic elements" class="paginator">
  </mat-paginator>

</div>